export const PURCHASE_METHODS = ['cash', 'loan', 'lease'] as const;
export type PurchaseMethod = typeof PURCHASE_METHODS[number];
